import { createFileRoute } from '@tanstack/react-router';
import { SeoContentPage } from '@/pages/SeoContentPage';

export const Route = createFileRoute('/_authed/seo/content')({
  component: SeoContentPage,
});
